import template from "./upload.html";
import "./upload.scss";
import { forEach } from "lodash";

class UploadController {
	constructor($upload, $element, $mdDialog, $ToastService) {
		"ngInject";
		this.$upload = $upload;
		this.$element = $element;
		this.id = Math.random().toString(36).substring(7);
		this.disabled = !!this.disabled;
		this.isUploading = false;
		this.$mdDialog = $mdDialog;
		this.toastService = $ToastService;
	}

    getFilesFromEvent($event) {
        // Prefer the real input element
        if ($event && $event.target && $event.target.files) {
            return $event.target.files;
        }
        // Fallback for form submit events (target can be the form, children are inputs)
        if ($event && $event.target && $event.target[0] && $event.target[0].files) {
            return $event.target[0].files;
        }
        // Last resort: pick the first input inside component
        const inputEl = this.$element && this.$element.find ? this.$element.find("input")[0] : null;
        return inputEl && inputEl.files ? inputEl.files : null;
    }

	$onSubmit($event) {
        const files = this.getFilesFromEvent($event);
        if (!this.uri) {
            this.showCustomError("Upload endpoint is not configured.");
            return;
        }
        if (!files || !files.length) {
            this.showCustomError("No files selected.");
            return;
        }
        if (this.maxSize && !this.isFileSizeValid(files)) {
            this.showCustomError(`Maximum file size is ${this.maxSize}mb`);
            return;
        }
		if (this.multiple) {
			//create images to check width/height
			let images = [];
			let count = files.length;
			let counter = 0;
			let valid = true;

			forEach(files, (f) => {
				if (!this.checkFileType(f.name)) {
					valid = false;
					return false;
				}
			});
			if (!valid) {
				return;
			}
            let incrementCounter = () => {
                counter++;
                if ( counter === count ) {
					// Check loaded images
                    let validW = images[0].naturalWidth;
                    let validH = images[0].naturalHeight;
                    forEach(images, (img) => {
						if (img.naturalHeight !== validH || img.naturalWidth !== validW) {
							valid = false;
							this.showCustomError("Uploaded photos should be the same size!");
						}
					});

                    if (!valid) {
						return;
					}

					// Check with first image
                    if (this.imagesArray && this.imagesArray.length) {
                        let firstImage = new Image();
                        firstImage.src = this.imagesArray[0];
                        firstImage.onload = () => {
                            const validWidth = firstImage.naturalWidth;
                            const validHeight = firstImage.naturalHeight;

                            forEach(images, (img) => {
                                if (img.naturalWidth !== validWidth || img.naturalHeight !== validHeight) {
                                    valid = false;
                                }
							});

                            if (valid) {
                                this.uploadFew(files);
                            } else {
                                this.showError(validWidth, validHeight);
                            }
                        };
                    } else {
                        this.uploadFew(files);
                    }
                }
            };

			forEach(files, (f) => {
				let image = new Image();
				image.src = window.URL.createObjectURL(f);
				images.push(image);
			});

			forEach(images, (img) => {
				img.addEventListener("load", incrementCounter, false);
			});

			//this.uploadFew($event);
		} else {
            if (!this.checkFileType(files[0].name)) {
                return;
            }

            if(this.fileTypes === ".pdf" || files[0].name.includes(".pdf") && this.fileTypes.includes(".pdf")) {
                //remove old file from backend
                if(this.oldFile){
                    if (this.oldFile !== undefined || this.oldFile !== "") {
                        this.$upload.delete("/api/attachments/"+this.oldFile+"/");
                    }
                }
                this.isUploading = true;
                this.upload(files);
            }else {
                if (this.isVideo(files[0].name) || this.isFont(files[0].name)) {
                    this.upload(files);
                } else {
                    this.isUploading = true;
                    let image = new Image();
                    image.src = window.URL.createObjectURL( files[0] );
                    image.onload = () => {
                        const width  = image.naturalWidth,
                            height = image.naturalHeight;

                        window.URL.revokeObjectURL(image.src);
                        if (this.imagesArray && this.imagesArray.length) {
                            let firstImage = new Image();
                            firstImage.src = this.imagesArray[0];
                            firstImage.onload = () => {
                                const validWidth = firstImage.naturalWidth;
                                const validHeight = firstImage.naturalHeight;

                                if (width !== validWidth || height !== validHeight) {
                                    this.isUploading = false;
                                    this.showError(validWidth, validHeight);
                                } else {
                                    this.upload(files);
                                }
                            };
                        } else {
                            this.upload(files);
                        }
                    };
                }
            }

		}
	}

	showError(width, height) {
        if (!this.hideErrorPopup) {
            this.$mdDialog.show(
                this.$mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title(`Error`)
                    .htmlContent(`<p>All files should be the same size as first one (${width}x${height})</p>`)
                    .ariaLabel("Error")
                    .ok("OK")
                    .targetEvent(event)
            );
        } else {
            this.toastService.showError(`All files should be the same size as first one (${width}x${height})`, 5000, "top right");
        }

	}

    showCustomError(text) {
        if (!this.hideErrorPopup) {
            this.$mdDialog.show(
                this.$mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title(`Error`)
                    .htmlContent(`<p>${text}</p>`)
                    .ariaLabel("Error")
                    .ok("OK")
                    .targetEvent(event)
            );
        } else {
            this.toastService.showError(text, 5000, "top right");
        }
    }

	upload(files) {
        const previousAttachment = this.deletePrevious ? this.model : null;
        this.isUploading = true;
        this.$upload
            .upload(files[0], this.uri, null, this.isOverlay)
            .then((response) => {
                this.model = response.data;
                this.removeReplacedAttachment(previousAttachment, response.data);
                this.callback && this.callback({file: response.data});
            }, (error) => {
                console.log(error);
                if(error.status === 415) {
                    this.showCustomError(error.data.detail);
                }
            })
            .then(() => this.$element.find("input")[0].value = null)
            .finally(() => this.isUploading = false);
	}

	removeReplacedAttachment(previousAttachment, nextAttachment) {
		if (!this.deletePrevious || !previousAttachment) {
			return;
		}
		const previousId = this.$upload.attachmentId(previousAttachment);
		const nextId = this.$upload.attachmentId(nextAttachment);
		if (!previousId || previousId === nextId) {
			return;
		}
		this.$upload.deleteCompanyAttachment(this.uri, previousAttachment);
	}

	uploadFew(files) {
        this.isUploading = true;
        // `files` може бути FileList (array-like), тому конвертуємо в справжній масив
        let filesArray = Array.isArray(files) ? files : Array.from(files || []);
        let collator = new Intl.Collator(undefined, {numeric: true, sensitivity: "base"});
        filesArray = filesArray.sort((a, b) => collator.compare(a.name, b.name));
        this.$upload
            .uploadFew(filesArray, this.uri, null, this.isOverlay)
            .then((response) => {
                //this.model = response.data;
                this.callback && this.callback({file: response.data});
            }, (error) => {
                console.log(error);
            })
            .then(() => this.$element.find("input")[0].value = null)
            .finally(() => this.isUploading = false);
	}

	checkFileType(file) {
        if (!file) {
            return false;
        }
        let fileExtention = file.split(".")[file.split(".").length - 1];
        if (this.fileTypes.indexOf(fileExtention) === -1) {
            this.$mdDialog.show(
                this.$mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title(`Error`)
                    .htmlContent(`<p><strong>${fileExtention.toUpperCase() }</strong> file type is not allowed!</p>`)
                    .ariaLabel("Error")
                    .ok("OK")
                    .targetEvent(event)
            );
            return false;
        }
        return true;
    }

    isVideo(name) {
        return name.indexOf(".mp4") !== -1 || name.indexOf(".webm") !== -1 || name.indexOf(".gif") !== -1 || name.indexOf(".mov") !== -1;
    }

    isFont(name) {
        return /\.(ttf|otf|woff2?)$/i.test(name);
    }

    isFileSizeValid(files) {
        let valid = true;

        forEach(files, (file) => {
            if (file.size > (this.maxSize * 1000000)) {
                valid = false;
            }
        });

        return valid;
    }
}

export const UploadComponent = {
	template,
	controller: UploadController,
	controllerAs: "upload",
	bindings: {
		model: "=?",
		uri: "@",
		callback: "&",
		customLabel: "@",
		extraInfo: "@",
		disabled: "<",
		imagesArray: "<",
        fileTypes: "@",
		multiple: "<",
        hideErrorPopup: "<",
        maxSize: "<",
        oldFile: "<",
        deletePrevious: "<",
        isOverlay: "@",
        uploadAnimatedFiles: "<",
        displayIcon: "@"
	}
};



// WEBPACK FOOTER //
// ./sources/utility/upload/upload.component.js